module.exports = __webpack_public_path__ + "static/media/rs.d434cbd6.webp";